import * as firebase from 'firebase/app'
import { firestore, storage, geofirestore, } from "firebaseHelpers";
import { Geokit, } from 'geokit'
import Moment from 'moment'
import { DELETE, } from 'constants/filesStatus'
import { CANCELED, REFUSED, } from 'constants/bookingStatus'
import { PARKING_VALIDATED, PARKING_REJECTED, PARKING_NEEDS_VALIDATION, } from 'constants/parkingStatus'
import { PAID, } from 'constants/withdrawalStatus'
import { getUserInfosFromEmail, getUserInfos, fetchWithdrawalsFilter, } from './users'

const fetchParkingsFilter = (filters, ownerData, delegateData, parkingId) => {
  let parkingsQuery = parkingId ? geofirestore.collection('parkings').doc(parkingId) : geofirestore.collection('parkings')

  if (filters) {
    if (typeof filters.parkingName !== 'undefined' && filters.parkingName !== '') {
      parkingsQuery = parkingsQuery.where('nameInsensitive', '==', filters.parkingName.toLowerCase())
    }
    if (typeof filters.city !== 'undefined' && filters.city !== '') {
      parkingsQuery = parkingsQuery.where('city', '==', filters.city)
    }
    if (typeof filters.access !== 'undefined') {
      parkingsQuery = parkingsQuery.where('access', 'array-contains', filters.access)
    }
    if (typeof filters.type !== 'undefined') {
      parkingsQuery = parkingsQuery.where('type', '==', filters.type)
    }
    if (typeof filters.status !== 'undefined') {
      parkingsQuery = parkingsQuery.where('status', '==', filters.status)
    }
    if (typeof filters.ownerEmail !== 'undefined' && filters.ownerEmail !== '') {
      parkingsQuery = parkingsQuery.where('owner', '==', firestore.collection('users').doc(ownerData.id))
    }
    if (typeof filters.delegateEmail !== 'undefined' && filters.delegateEmail !== '') {
      parkingsQuery = parkingsQuery.where('delegate', '==', firestore.collection('users').doc(delegateData.id))
    }
    if (typeof filters.partnerEmail !== 'undefined' && filters.partnerEmail !== '') {
      parkingsQuery = parkingsQuery.where('managersEmail', 'array-contains', filters.partnerEmail.toLowerCase())
    }
    if (typeof filters.parkingType !== 'undefined' && filters.parkingType !== '') {
      parkingsQuery = parkingsQuery.where('type', '==', Number(filters.parkingType))
    }
  }
  return parkingsQuery
}

export const fetchUserParkings = async (parkings, filters) => {
  return new Promise(async (resolve, reject) => {
    try {
      let parkingsList = []

      const parkingsQuery = await Promise.all(parkings.map((parking) => (parking.get())))

      parkingsList = parkingsQuery.reduce((acc, parking) => {
        return { docs: [ ...acc.docs, parking ] }
      }, { docs: [] })

      const formatedData = parkingsList.docs.map((parking) => {
        const data = parking.data()
        return parking.exists ? {
          ...data.d,
          id: parking.id,
        } : { id: parking.id, doesNotExists: true, }
      })
      resolve(formatedData.filter((parking) => {
        if (parking.doesNotExists) {
          return false
        }
        if (filters) {
          if (filters.parkingName && !parking.nameInsensitive.includes(filters.parkingName)) {
            return false
          }
          if (filters.city && !parking.city.toLowerCase().includes(filters.city.toLowerCase())) {
            return false
          }
          if (typeof filters.access !== 'undefined' && !parking.access.includes(filters.access)) {
            return false
          }
          if (typeof filters.type !== 'undefined' && parking.type !== filters.type) {
            return false
          }
        }
        return true
      }))
    } catch (error) {
      reject(error.message)
    }
  })
}

export const fetchParkings = async (filters, restrictedParkings) => {
  return new Promise(async (resolve, reject) => {
    try {
      let parkingsList = []

      const ownerData = filters && typeof filters.ownerEmail !== 'undefined' && filters.ownerEmail !== '' ? await getUserInfosFromEmail(filters.ownerEmail.toLowerCase()) : {}
      const delegateData = filters && typeof filters.delegateEmail !== 'undefined' && filters.delegateEmail !== '' ? await getUserInfosFromEmail(filters.delegateEmail.toLowerCase()) : {}

      if (restrictedParkings) {
        const parkingsQuery = await Promise.all(restrictedParkings.map((parking) => (fetchParkingsFilter(filters, ownerData, delegateData, parking).get())))
        parkingsList = parkingsQuery.reduce((acc, parking) => {
          return { docs: [ ...acc.docs, parking ] }
        }, { docs: [] })
      } else {
        parkingsList = await fetchParkingsFilter(filters, ownerData, delegateData).get()
      }
      const formatedData = parkingsList.docs.map((parking) => {
        const data = parking.data()
        return {
          id: parking.id,
          ...data,
          created: data.created ? data.created.toDate() : null,
        }
      }).sort((a, b) => {
        if (a.created && !b.created) {
          return -1
        } else if (!a.created && b.created) {
          return 1
        }
        const momentA = Moment(a.created)
        const momentB = Moment(b.created)

        if (momentA.isAfter(momentB)) {
          return -1
        }
        if (momentA.isBefore(momentB)) {
          return 1
        }
        return 0
      })
      resolve(formatedData)
    } catch (error) {
      reject(error.message)
    }
  })
}

export const fetchParkingData = async (parkingId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const parkingInfos = await geofirestore.collection('parkings').doc(parkingId).get()
      const data = parkingInfos.data()
      const formatedData = {
        ...data,
        id: parkingId,
        ownerData: data.owner ? await getUserInfos(data.owner.id) : null,
        delegateData: data.delegate ? await getUserInfos(data.delegate.id) : null,
      }
      resolve(formatedData)
    } catch (error) {
      reject(error.message)
    }
  })
}

export const uploadParkingImages = async (files, options = {}) => {
  return new Promise(async (resolve, reject) => {
    const updateFiles = await Promise.all(files.map((file, index) => {
      return new Promise(async (resolve, reject) => {
        try {
          if (typeof file.name == 'string') {
            const fileData = await storage.ref().child(`parkings/${options.parkingId}/${file.name}`).put(file)
            const downloadURL = await fileData.ref.getDownloadURL()
            const splitedPath = downloadURL.split('%2F')
            const imageSmall = splitedPath.map((path, index) => {
              if (index === splitedPath.length - 1) {
                return `thumb@compressed_${path}`
              }
              return path
            }).join('%2F')

            resolve({ url: downloadURL, urlSmall: imageSmall, fileName: file.name })
          } else if (file.status === DELETE) {
            await storage.ref().child(`parkings/${options.parkingId}/${file.fileName}`).delete()
            await storage.ref().child(`parkings/${options.parkingId}/thumb@compressed_${file.fileName}`).delete()

            resolve({ url: null, urlSmall: null, fileName: null })
          } else {
            const splitedPath = file.url.split('%2F')
            const imageSmall = splitedPath.map((path, index) => {
              if (index === splitedPath.length - 1) {
                return `thumb@compressed_${path}`
              }
              return path
            }).join('%2F')

            resolve({ ...file, urlSmall: imageSmall, })
          }
        } catch (error) {
          resolve({ url: null, urlSmall: null, fileName: null })
        }
      })
    }))
    const filteredFiles = updateFiles.filter((file) => (file.url !== null))
    resolve({
      url: options.isMulti ? filteredFiles.map((file) => file.url) : (filteredFiles.length !== 0 ? filteredFiles[0].url : ''),
      urlSmall: options.isMulti ? filteredFiles.map((file) => file.urlSmall) : (filteredFiles.length !== 0 ? filteredFiles[0].urlSmall : ''),
      names: options.isMulti ? filteredFiles.map((file) => file.fileName) : (filteredFiles.length !== 0 ? filteredFiles[0].fileName : ''),
    })
  })
}

export const editParking = async (parkingId, parkingInfos, oldOwner, oldDelegate) => {
  return new Promise(async (resolve, reject) => {
    try {
      const parking = geofirestore.collection('parkings').doc(parkingId)

      await parking.set({
        access: parkingInfos.access,
        adURLName: parkingInfos.adURLName,
        adURL: parkingInfos.adURL,
        adaptedVehicles: parkingInfos.adaptedVehicles,
        address: parkingInfos.address,
        autoBooking: parkingInfos.autoBooking,
        canSetAd: parkingInfos.canSetAd,
        characteristics: parkingInfos.characteristics,
        city: parkingInfos.city,
        delegate: parkingInfos.delegate,
        delegateCheckin: parkingInfos.delegateCheckin,
        description: parkingInfos.description,
        ejariURL: parkingInfos.ejariURL,
        ejariURLSmall: parkingInfos.ejariURLSmall,
        gateManagers: parkingInfos.gateManagers,
        images: parkingInfos.images,
        imagesName: parkingInfos.imagesName,
        imagesSmall: parkingInfos.imagesSmall,
        instructions: parkingInfos.instructions,
        isAvailable: parkingInfos.isAvailable,
        logo: parkingInfos.logo,
        logoName: parkingInfos.logoName,
        logoSmall: parkingInfos.logoSmall,
        managers: parkingInfos.managers,
        maxHeight: parkingInfos.maxHeight,
        name: parkingInfos.name,
        nameInsensitive: parkingInfos.nameInsensitive,
        owner: parkingInfos.owner,
        partnerEmail: parkingInfos.partnerEmail,
        price: parkingInfos.price,
        phoneNumber: parkingInfos.phoneNumber,
        pricesAvailability: parkingInfos.pricesAvailability,
        serviceCharge: parkingInfos.serviceCharge,
        status: parkingInfos.status,
        totalSpaces: Number(parkingInfos.totalSpaces),
        type: parkingInfos.type,
        vat: parkingInfos.vat,
      }, { merge: true })

      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

export const deleteParking = async (parkingId, parkingInfos) => {
  return new Promise(async (resolve, reject) => {
    try {
      const parking = geofirestore.collection('parkings').doc(parkingId)
      await parking.delete()
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

export const getNewParkingId = async (latitude: number, longitude: number, index: number, increment: number) => {
  const dataOffset = [
    { latitude: 0, longitude: 0 },
    { latitude: 0.000001, longitude: 0 },
    { latitude: 0, longitude: 0.000001 },
    { latitude: -0.000001, longitude: 0 },
    { latitude: 0, longitude: -0.000001 },
    { latitude: 0.000001, longitude: 0.000001 },
    { latitude: -0.000001, longitude: -0.000001 },
  ]
  return new Promise(async (resolve, reject) => {
    const location = {
      lat: Number(latitude + (dataOffset[index].latitude * increment)),
      lng: Number(longitude + (dataOffset[index].longitude * increment)),
    }
    const hash = Geokit.hash(location)
    const parking = await geofirestore.collection('parkings').doc(hash).get()
    if (parking.exists) {
      const newIndex = index + 1 === dataOffset.length ? 0 : index + 1
      const newIncrement = index + 1 === dataOffset.length ? increment + 1 : increment
      const parkingData = await getNewParkingId(latitude, longitude, newIndex, newIncrement)
      resolve({
        parkingId: parkingData.parkingId,
        latitude: parkingData.latitude,
        longitude: parkingData.longitude,
      })
    } else {
      resolve({
        parkingId: hash,
        latitude: Number(latitude + (dataOffset[index].latitude * increment)),
        longitude: Number(longitude + (dataOffset[index].longitude * increment)),
      })
    }
  })
}

export const createParking = async (parkingId, parkingInfos) => {
  return new Promise(async (resolve, reject) => {
    try {
      const parking = geofirestore.collection('parkings').doc(parkingId)

      await parking.set({
        ...parkingInfos,
        status: 1,
        rating: 0,
        priceTotal: 0,
        nbRatings: 0,
        lastBooking: null,
        currency: 'AED',
        coordinates: new firebase.firestore.GeoPoint(parkingInfos.latitude, parkingInfos.longitude)
      })
      resolve(parkingId)
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchEarnings = async (from, to, parkingId) => {
  return new Promise(async (resolve, reject) => {
    try {
      let nbBookings = 0
      let totalRefundable = 0
      const reservations = await firestore.collection('parkings').doc(parkingId).collection('reservations').where('reservationDate', '>=', from.toDate()).where('reservationDate', '<', to.add(1, 'days').toDate()).get()
      const reservationsFormated = Object.values(reservations.docs.reduce((acc, booking) => {
        const bookingData = booking.data()
        const bookingDay = Moment(bookingData.reservationDate.toDate()).startOf('day').format('X')

        if (booking.status === CANCELED || booking.status === REFUSED) {
          return acc
        } else if (acc[bookingDay]) {
          nbBookings++
          totalRefundable += bookingData.refundablePartner
          return {
            ...acc,
            [bookingDay]: {
              date: bookingDay,
              totalPaid: acc[bookingDay].totalPaid + bookingData.totalPaid,
              totalPrice: acc[bookingDay].totalPrice + bookingData.totalPrice,
              sumPaidWithCredits: acc[bookingDay].sumPaidWithCredits + bookingData.sumPaidWithCredits,
              refundablePartner: acc[bookingDay].refundablePartner + bookingData.refundablePartner,
            },
          }
        } else {
          nbBookings++
          totalRefundable += bookingData.refundablePartner
          return {
            ...acc,
            [bookingDay]: {
              date: bookingDay,
              totalPaid: bookingData.totalPaid,
              totalPrice: bookingData.totalPrice,
              sumPaidWithCredits: bookingData.sumPaidWithCredits,
              refundablePartner: bookingData.refundablePartner,
            },
          }
        }
      }, {}))

      resolve({
        totalIncome: totalRefundable,
        totalBookings: nbBookings,
        data: reservationsFormated.sort((a, b) => {
          if (a.date > b.date) {
            return 1
          }
          if (a.date < b.date) {
            return -1
          }
          return 0
        })
      })
    } catch (error) {
      reject(error)
    }
  })
}

export const declineParking = (parkingId) => {
  return new Promise(async (resolve, reject) => {
    try {
      await geofirestore.collection('parkings').doc(parkingId).set({
        status: PARKING_REJECTED,
      }, { merge: true })
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

export const validateParking = (parkingId) => {
  return new Promise(async (resolve, reject) => {
    try {
      await geofirestore.collection('parkings').doc(parkingId).set({
        status: PARKING_VALIDATED,
      }, { merge: true })
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchParkingsNeedValidation = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const parkings = await geofirestore.collection('parkings').where('status', '==', PARKING_NEEDS_VALIDATION).get()

      resolve(parkings.docs.length)
    } catch (error) {
      reject(error)
    }
  })
}

export const fetchParkingWithdrawals = async (filters, parkingId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const withdrawals = await fetchWithdrawalsFilter(filters, null, parkingId).get()

      resolve(withdrawals.docs.map((withdrawal) => {
        const withdrawalData = withdrawal.data()
        return {
          ...withdrawalData,
          id: withdrawal.id,
          date: withdrawalData.date.toDate(),
        }
      }).sort((a, b) => {
        const momentA = Moment(a.date)
        const momentB = Moment(b.date)

        if (momentA.isAfter(momentB)) {
          return -1
        }
        if (momentA.isBefore(momentB)) {
          return 1
        }
        return 0
      }))
    } catch (error) {
      reject(error)
    }
  })
}

export const createWithdrawal = async (form, parkingInfos) => {
  return new Promise(async (resolve, reject) => {
    try {
      await firestore.collection('parkings').doc(parkingInfos.id).collection('withdrawals').add({
        ...form,
        parkingId: parkingInfos.id,
        parkingName: parkingInfos.name,
        date: new Date(),
        status: PAID,
      })
      resolve()
    } catch (error) {
      reject(error)
    }
  })
}
